export const DOCUMENT_TYPE = {
  ESTIMATE: 'estimate',
  INVOICE: 'invoice',
}
export const AMOUNT_TYPE = {
  FLAT: 'flat',
  PERCENT: 'percent',
}
export const DETAIL_PORTAL = 'Detail Portal - Mobile Tech RX'
